<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import realizarMedicionesAPI from "@/services/standards/realizarMediciones/realizarMedicionesAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import RealizarMedicionesPagination from "../../../components/standard/realizarMediciones/RealizarMedicionesPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.1.4 Realización de mediciones ambientales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    RealizarMedicionesPagination,
  },
  data() {
    return {
      title:
        "4.1.4 Realización de mediciones ambientales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.1.4 Realización de mediciones ambientales",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",

      file: null,

      medicion: {
        date: null,
        observations: null,
        copasst_information: "NO",
        file: null,
        types_measurements_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      lastId: 1,
      deleteCount: 0,
      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      form_submitting: false,

      loading1: true,
      loading2: true,
      loading3: true,

      lista: [],
      item: null,
      itemStatus: "No cumplido",

      itemData: null,

      options: [
        {
          id: 1,
          description: "Iluminación",
        },
        {
          id: 2,
          description: "Sonometría",
        },
        {
          id: 3,
          description: "Dosimetría",
        },
        {
          id: 4,
          description: "Estrés térmico",
        },
        {
          id: 5,
          description: "Material particulado",
        },
        {
          id: 6,
          description: "Humos metálicos",
        },
        {
          id: 7,
          description: "Vibraciones",
        },
        {
          id: 8,
          description: "Sustancias químicas ",
        },
      ],
    };
  },
  validations: {
    file: {
      required,
    },
    medicion: {
      date: {
        required,
      },
      copasst_information: {
        required,
      },
      types_measurements_id: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(44)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.1.4/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/4.1.4/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.medicion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading1 = false;
        return;
      } else {
        let response = await this.uploadDocument();
        if (response) {
          realizarMedicionesAPI
            .save(this.medicion)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 44,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.sendNotification(72, 44, true);
                  this.loading1 = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1500);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1500);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido registrar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 44)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 44,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    deletemediciones(id) {
      realizarMedicionesAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 44,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getMediciones() {
      realizarMedicionesAPI
        .get(this.companyID)
        .then((response) => {
          this.list = response.data.data;
          if (Array.isArray(this.list)) {
            this.deleteCount = this.list.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getList() {
      realizarMedicionesAPI
        .getList(this.companyID)
        .then((response) => {
          this.loading = false;
          this.lista = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getList();
    this.getItems();
    this.getItemData();
    this.getMediciones();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe realizar mediciones ambientales de los
                      riesgos prioritarios ayudan a identificar, evaluar y
                      controlar aquellos peligros físicos, químicos y biológicos
                      que afectan la salud de los colaboradores.
                    </p>
                    <p class="text-justify">
                      Según la actividad que realice la empresa, los estudios
                      ambientales pueden ser:
                    </p>
                    <ul>
                      <li>Evaluación de exposición al polvo</li>

                      <li>Calidad del aire</li>

                      <li>Evaluación de Gases y Vapores</li>

                      <li>Evaluación y exposición de ruidos</li>

                      <li>Sistemas de Iluminación</li>

                      <li>Evaluación de Estrés térmico</li>

                      <li>
                        Evaluación de vibraciones mano-brazo, de cuerpo entero
                        entre otros.
                      </li>
                    </ul>

                    <p class="text-justify">
                      En este ítem la empresa deberá almacenar los informes de
                      las mediciones realizadas.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2 px-2">
                  <b-form-group class="col-md-4 px-2" label="Tipos de mediciones" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme" :class="{
                      'is-invalid':
                        submitted && $v.medicion.types_measurements_id.$error,
                    }" v-model="medicion.types_measurements_id">
                      <b-form-select-option v-for="item in lista" :value="item.id" :key="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.medicion.types_measurements_id.$error
                    ">
                      <small v-if="!$v.medicion.types_measurements_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Fecha de la medición" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.date" type="date"
                      id="input-sm" :class="{
                        'is-invalid': submitted && $v.medicion.date.$error,
                      }" placeholder="fecha">
                    </b-form-input>
                    <div v-if="submitted && $v.medicion.date.$error">
                      <small v-if="!$v.medicion.date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir informe de la medición" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar" :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..."
                      v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :class="{
                        'is-invalid': $v.file.$error && submitted,
                      }">
                    </b-form-file>
                    <div v-if="submitted && $v.file.$error">
                      <small v-if="!$v.file.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="medicion.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <p class="col-md-4">
                    ¿Los resultados fueron informados al COPASST?
                  </p>
                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-1 d-flex flex-row ml-5">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.copasst_information"
                      :aria-describedby="ariaDescribedby" name="some-radios" value="SI">Si</b-form-radio>
                  </b-form-group>
                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-1 d-flex flex-row">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.copasst_information"
                      :aria-describedby="ariaDescribedby" name="some-radios" value="NO">No</b-form-radio>
                    <div v-if="submitted && $v.medicion.copasst_information.$error">
                      <small v-if="!$v.medicion.copasst_information.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr class="px-2" />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3 px-2">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table
                        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                        <thead class="table-active">
                          <tr>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Fecha
                            </th>

                            <th scope="col"
                              class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Fecha de la medición
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Tipo de medición
                            </th>

                            <th scope="col"
                              class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Ver archivo
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-6">
                              Observaciones
                            </th>
                            <th scope="col"
                              class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-5">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="item in list" :key="item.id">
                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ dateConvert(item.created_at) }}
                            </td>

                            <td class="px-6 text-center text-sm text-gray-500 mx-2">
                              {{ item.date }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.name }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                              <div v-if="item.file === null">
                                <h6>No hay archivo disponible</h6>
                              </div>
                              <div v-else>
                                <button :disabled="!allowAccess()" style="
                                   background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="gotoDigitalOcean(`${item.file}`)">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </div>
                            </td>
                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.observations }}
                            </td>
                            <td class="px-6 text-sm text-gray-500 mx-2 text-center">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')
                                  ">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " v-b-modal="`modal${item.id}`">
                                    Editar
                                  </b-dropdown-item>
                                  <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                    <div class="text-justify">
                                      <h4 class="mt-2 text-primary text-center">
                                        Advertencia
                                      </h4>
                                      <p class="mt-3">
                                        Al modificar esta información se quitará
                                        el puntaje correspondiente a este ítem y
                                        será necesario realizar nuevamente la
                                        validación por parte del usuario
                                        responsable de Emisión.
                                      </p>
                                      <button type="button" @click="
                                        goPage(
                                          `/forms/estandares/realizar-mediciones-editar/${item.id}`
                                        )
                                        " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                        :disabled="!allowAccess()">
                                        Continuar
                                      </button>
                                      <button type="button" @click="
                                        $bvModal.hide(`modal${item.id}`)
                                        " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                        Cancelar
                                      </button>
                                    </div>
                                  </b-modal>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " :to="{
                                      path: `/forms/estandares/realizar-mediciones-ver/${item.id}`,
                                    }">
                                    Ver
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                    " v-on:click="deletemediciones(item.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <RealizarMedicionesPagination ref="paginator" @loading="(load) => (loading = load)"
                        :search="search" @fetch="(items) => (list = items)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
